import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import "./View.css";

import * as React from 'react';
import { Document, Page, pdfjs, Thumbnail } from "react-pdf";
import Swal from 'sweetalert2';
import { FaDownload, FaCertificate, FaCheck } from "react-icons/fa";
import * as QueryString from "query-string";
import { verifyPDF } from './verify-pdf';
import { FiRotateCw } from 'react-icons/fi';
import { DocumentCallback } from 'react-pdf/dist/cjs/shared/types';
import { Spinner } from 'reactstrap';
//const { verifyPDF } = require('./verify-pdf');

const PDFThumnail = React.lazy(() => import('./PDFThumnail'));

// Start with react-pdf; switch only after a black-canvas check or a user request.
const options = {
    // Test image rendering without the worker OffscreenCanvas path.
    isOffscreenCanvasSupported: false,
    // The CDN worker needs absolute URLs to fetch these assets from this app.
    cMapUrl: new URL('/cmaps/', window.location.href).href,
    cMapPacked: true,
    standardFontDataUrl: new URL('/standard_fonts/', window.location.href).href,
};

//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// from another branch
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// from doc
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

// Keep the legacy worker; OffscreenCanvas is explicitly disabled in options above.
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.mjs`;

class PDFView extends React.Component<any, {
    filePath: string,
    params: string,
    readOnly: boolean,
    numPages: number,
    pageNumber: number,
    scaleIndex: number,
    scaleList: number[],
    defaultPageRotates: number[],
    base64PDF: string | ArrayBuffer | null,
    isSigned: boolean,
    showSigned: boolean,
    signedBy: string,
    signedEmail: string,
    signedOn: string,
    rotation: number,
    count: number;
    pdfDocumentProxy?: DocumentCallback;
    fetching?: boolean;
    useNativeViewer: boolean;
    blobUrl: string | null;
    detecting: boolean;
    nativePreviewUrl: string | null;
    nativeRotating: boolean;
}> {
    private pageCanvas = React.createRef<HTMLCanvasElement>();
    private blackCheckTimer: number | undefined;
    private viewerUnmounted = false;
    private nativeRotationInProgress = false;
    private nativePreviewUrls = new Set<string>();

    private cancelBlackCheck = () => {
        if (this.blackCheckTimer !== undefined) {
            window.clearTimeout(this.blackCheckTimer);
            this.blackCheckTimer = undefined;
        }
    };

    private openNativeViewer = (reason: string) => {
        this.cancelBlackCheck();
        if (this.viewerUnmounted || this.state.useNativeViewer) return;
        console.info('[PDFView] switching to native:', reason);
        this.setState({ useNativeViewer: true }, () => {
            if (this.state.rotation !== 0) this.rotateNativePreview(this.state.rotation);
        });
    };

    private onPageRenderSuccess = () => {
        this.cancelBlackCheck();
        const canvas = this.pageCanvas.current;
        const { pageNumber, scaleIndex, rotation } = this.state;
        if (!canvas || this.state.useNativeViewer || this.viewerUnmounted) return;

        const check = (confirmation: boolean) => {
            this.blackCheckTimer = undefined;
            if (this.viewerUnmounted || this.state.useNativeViewer ||
                this.pageCanvas.current !== canvas || this.state.pageNumber !== pageNumber ||
                this.state.scaleIndex !== scaleIndex || this.state.rotation !== rotation ||
                !canvas.width || !canvas.height) return;
            try {
                // Sample the actual canvas, not a rescaled copy that can hide small light areas.
                const context = canvas.getContext('2d');
                if (!context) return;
                const grid = 32;
                let black = 0;
                for (let row = 0; row < grid; row++) {
                    const y = Math.floor((row + 0.5) * canvas.height / grid);
                    const pixels = context.getImageData(0, y, canvas.width, 1).data;
                    for (let col = 0; col < grid; col++) {
                        const offset = Math.floor((col + 0.5) * canvas.width / grid) * 4;
                        if (pixels[offset + 3] >= 250 && pixels[offset] <= 10 &&
                            pixels[offset + 1] <= 10 && pixels[offset + 2] <= 10) black++;
                    }
                }
                const ratio = black / (grid * grid);
                console.info('[PDFView] canvas check:', { pageNumber, blackRatio: ratio, confirmation });
                if (ratio >= 0.995) {
                    if (confirmation) {
                        this.openNativeViewer('canvas remained at least 99.5% black on two checks');
                    } else {
                        this.blackCheckTimer = window.setTimeout(() => check(true), 400);
                    }
                }
            } catch (error) {
                // A readback failure is not evidence of a black page. Manual fallback stays available.
                console.warn('[PDFView] canvas check unavailable:', error);
            }
        };
        this.blackCheckTimer = window.setTimeout(() => check(false), 100);
    };

    constructor(props: any) {
        super(props);

        this.state = {
            filePath: '',
            params: '',
            readOnly: false,
            numPages: 0,
            pageNumber: 1,
            scaleIndex: 7,
            scaleList: [0.25, 0.33, 0.5, 0.67, 0.75, 0.80, 0.90, 1, 1.11, 1.25, 1.50, 1.75, 2.0, 2.5, 3, 4, 5],
            defaultPageRotates: [],
            base64PDF: null,
            isSigned: false,
            showSigned: true,
            signedBy: '',
            signedEmail: '',
            signedOn: '',
            rotation: 0,
            count: 0,
            pdfDocumentProxy: undefined,
            fetching: false,
            useNativeViewer: false,
            blobUrl: null,
            detecting: false,
            nativePreviewUrl: null,
            nativeRotating: false
        }

        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.onClickGoToPreviousPage = this.onClickGoToPreviousPage.bind(this);
        this.onClickGoToNextPage = this.onClickGoToNextPage.bind(this);
        this.onClickScaleDown = this.onClickScaleDown.bind(this);
        this.onClickScaleUp = this.onClickScaleUp.bind(this);
        this.onClickDownload = this.onClickDownload.bind(this);
        this.onClickSignedBadge = this.onClickSignedBadge.bind(this);
        this.onLoadError = this.onLoadError.bind(this);
        this.onDocumentLoadError = this.onDocumentLoadError.bind(this);
    }

    componentDidMount() {
        var { filePath } = this.props
        let params = QueryString.parse(filePath.substr(filePath.lastIndexOf('?') + 1))
        var readOnly = false
        if (params.read_only) {
            if (String(params.read_only).toLowerCase() == 'true') {
                readOnly = true
            }
        }

        this.setState({ fetching: true });
        fetch(filePath, {
            method: "GET",
            signal: AbortSignal.timeout(120000) // 2 minute
        })
            .then(response => {
                if (response.ok) {
                    return response.blob()
                }
                throw new Error('Something went wrong');
            })
            .then(response => {
                var reader = new FileReader();
                reader.readAsArrayBuffer(response);
                reader.onloadend = () => {
                    var result = reader.result;
                    const verified = verifyPDF.verifyPDF(result);
                    var isSigned = false
                    var signedBy = ''
                    var signedEmail = ''
                    var signedOn = ''
                    if (!verified.message) {
                        var certs = verified.meta?.certs
                        for (let i = 0; i < certs.length; i++) {
                            if (certs[i].clientCertificate) {
                                var issuedTo = certs[i].issuedTo["commonName"]
                                var fixedstring = decodeURIComponent(escape(issuedTo));
                                isSigned = true
                                signedBy = fixedstring
                                signedEmail = ''
                                signedOn = verified.lastModify
                                break;
                            }
                        }
                    }
                    // Force application/pdf MIME type so browser renders inline, not downloads.
                    // Use a File (not a plain Blob) so the name carries through to the browser's
                    // native PDF viewer — its own Save/Download button then suggests the real filename.
                    const fileName = PDFView.extractFileNameFromPath(filePath) || 'document.pdf';
                    const pdfBlob = new File([result as ArrayBuffer], fileName, { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(pdfBlob);
                    this.setState({
                        filePath: filePath,
                        base64PDF: result,
                        readOnly: (readOnly != undefined) ? readOnly : false,
                        isSigned: isSigned,
                        signedBy: signedBy,
                        signedEmail: signedEmail,
                        signedOn: signedOn,
                        fetching: false,
                        blobUrl,
                        detecting: true
                    })
                }
            })
            .catch((error) => {
                if (error instanceof Error && error.name === 'TimeoutError') {
                    this.setState({ fetching: false })
                    this.onLoadError('ไฟล์มีขนาดใหญ่ กรุณา Download เพื่อเปิดไฟล์');
                } else {
                    this.setState({ fetching: false })
                    this.onLoadError('ไม่พบข้อมูล หรือไม่ได้รับสิทธิ์ให้เข้าดูไฟล์ กรุณาติดต่อผู้ดูแลระบบ');
                }
            })
    }

    componentWillUnmount() {
        this.viewerUnmounted = true;
        this.nativePreviewUrls.forEach(url => URL.revokeObjectURL(url));
        this.nativePreviewUrls.clear();
        this.cancelBlackCheck();
        if (this.state.blobUrl) {
            URL.revokeObjectURL(this.state.blobUrl);
        }
    }

    componentDidUpdate(_previousProps: any, previousState: Readonly<PDFView['state']>) {
        if (previousState.pageNumber !== this.state.pageNumber ||
            previousState.scaleIndex !== this.state.scaleIndex ||
            previousState.rotation !== this.state.rotation) {
            this.cancelBlackCheck();
        }
        let { numPages, pageNumber, scaleIndex, scaleList } = this.state
        if (pageNumber == 1) {
            var btnPreviousPage = document.getElementById('btnPreviousPage') as HTMLButtonElement;
            if ((btnPreviousPage != undefined) && (btnPreviousPage.disabled == false)) {
                btnPreviousPage.disabled = true;
            }
        } else {
            var btnPreviousPage = document.getElementById('btnPreviousPage') as HTMLButtonElement;
            if ((btnPreviousPage != undefined) && (btnPreviousPage.disabled == true)) {
                btnPreviousPage.disabled = false;
            }
        }

        if (pageNumber == numPages) {
            var btnNextPage = document.getElementById('btnNextPage') as HTMLButtonElement;
            if ((btnNextPage != undefined) && (btnNextPage.disabled == false)) {
                btnNextPage.disabled = true;
            }
        } else {
            var btnNextPage = document.getElementById('btnNextPage') as HTMLButtonElement;
            if ((btnNextPage != undefined) && (btnNextPage.disabled == true)) {
                btnNextPage.disabled = false;
            }
        }

        if (scaleIndex == 0) {
            var btnScaleDown = document.getElementById('btnScaleDown') as HTMLButtonElement;
            if ((btnScaleDown != undefined) && (btnScaleDown.disabled == false)) {
                btnScaleDown.disabled = true;
            }
        } else {
            var btnScaleDown = document.getElementById('btnScaleDown') as HTMLButtonElement;
            if ((btnScaleDown != undefined) && (btnScaleDown.disabled == true)) {
                btnScaleDown.disabled = false;
            }
        }

        if (scaleIndex == (scaleList.length - 1)) {
            var btnScaleUp = document.getElementById('btnScaleUp') as HTMLButtonElement;
            if ((btnScaleUp != undefined) && (btnScaleUp.disabled == false)) {
                btnScaleUp.disabled = true;
            }
        } else {
            var btnScaleUp = document.getElementById('btnScaleUp') as HTMLButtonElement;
            if ((btnScaleUp != undefined) && (btnScaleUp.disabled == true)) {
                btnScaleUp.disabled = false;
            }
        }

        // setTimeout(this.adjustScrollSpace, 0);
    }

    adjustScrollSpace = () => {
        const pdf = document.querySelector<HTMLCanvasElement>('.selected-document .react-pdf__Page__canvas');
        if (!pdf) {
            return;
        }

        const clientRect = pdf.getBoundingClientRect();
        if (clientRect.y < 0) {
            pdf.style.transform = `translateY(${-1 * clientRect.y}px)`;
        }
    }

    async onDocumentLoadSuccess(pdf: DocumentCallback) {
        const defaultPageRotates: number[] = []
        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
            const page = await pdf.getPage(pageNum);
            defaultPageRotates.push(page.rotate);
        }

        if (!this.state.detecting) {
            // Already past detection — just refresh proxy and page metadata
            this.setState({ pdfDocumentProxy: pdf, numPages: pdf.numPages, defaultPageRotates });
            return;
        }

        // Detect broken font encoding — fall back to browser native viewer if found.
        // PDF.js signals decoding failure in two ways:
        //   1. Items with str === '' (no ToUnicode mapping for the glyph)
        //   2. Items with garbage ASCII punctuation substituted for the real char
        let useNativeViewer = false;
        try {
            const page = await pdf.getPage(1);
            const textContent = await page.getTextContent();
            const items = (textContent.items as any[]).filter(item => 'str' in item);
            const totalItems = items.length;

            if (totalItems > 10) {
                const emptyItems = items.filter(item => item.str === '').length;
                const text = items.map(item => item.str as string).join('');
                const trimLen = text.trim().length;
                const punctCount = (text.match(/[!-/:-@\[-`{-~]/g) || []).length;
                console.log('[PDFView] font check — totalItems:', totalItems, 'emptyItems:', emptyItems, 'emptyRatio:', (emptyItems / totalItems).toFixed(2), 'trimLen:', trimLen, 'punctRatio:', trimLen > 0 ? (punctCount / trimLen).toFixed(2) : 'n/a');

                if (emptyItems / totalItems > 0.15) {
                    useNativeViewer = false;
                } else if (trimLen > 10 && punctCount / trimLen > 0.2) {
                    useNativeViewer = false;
                }
            } else {
                console.log('[PDFView] font check — totalItems too few:', totalItems);
                if (totalItems === 0) {
                    useNativeViewer = true; // image-only PDF (no text layer) — canvas render fails in WebView2
                }
            }
            if (!this.state.useNativeViewer) {
                console.log('[PDFView] starting react-pdf with OffscreenCanvas disabled; heuristic candidate:', useNativeViewer);
                useNativeViewer = false;
            }
            console.log('[PDFView] useNativeViewer:', useNativeViewer);
        } catch {
            // ignore detection errors — keep react-pdf
        }

        this.setState({
            pdfDocumentProxy: pdf,
            numPages: pdf.numPages,
            defaultPageRotates,
            useNativeViewer: this.state.useNativeViewer,
            detecting: false
        });
    }

    onDocumentLoadError() {
        this.onLoadError('ไม่พบข้อมูล หรือไม่ได้รับสิทธิ์ให้เข้าดูไฟล์ กรุณาติดต่อผู้ดูแลระบบ')
    }

    onLoadError(errorMessage: string) {
        Swal.fire({
            title: 'ไม่สำเร็จ!',
            // text: 'ไม่พบข้อมูล หรือไม่ได้รับสิทธิ์ให้เข้าดูไฟล์ กรุณาติดต่อผู้ดูแลระบบ',
            text: errorMessage,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'ยืนยัน!'
        }).then((result) => {
            if (result.value) {
            }

            this.setState({
                filePath: '',
                base64PDF: '',
                readOnly: true
            })
        })
    }

    changePage = (pageNumber: number) => {
        this.setState({ pageNumber });
    };

    onClickPageThumnail(pageNumber: number) {
        this.changePage(pageNumber);
    }

    onClickGoToPreviousPage() {
        const { pageNumber } = this.state;
        if (pageNumber > 1) {
            this.changePage(pageNumber - 1);
        }
    }

    onClickGoToNextPage() {
        const { numPages, pageNumber } = this.state;
        if (pageNumber < numPages) {
            this.changePage(pageNumber + 1);
        }
    }

    onClickScaleUp() {
        let { scaleIndex, scaleList } = this.state
        if (scaleIndex < scaleList.length - 1) {
            this.setState({
                scaleIndex: scaleIndex + 1
            })
        }
    }

    onClickScaleDown() {
        let { scaleIndex } = this.state
        if (scaleIndex > 0) {
            this.setState({
                scaleIndex: scaleIndex - 1
            })
        }
    }

    downloadFile(filePath) {
        fetch(filePath, {
            method: 'GET',
        }).then(function (resp) {
            return resp.blob();
        }).then(function (blob) {
            const newBlob = new Blob([blob], { /*type: "application/pdf", charset: "UTF-8"*/ })

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);

                return;
            }
            const data = window.URL.createObjectURL(newBlob);
            const link = document.createElement('a');
            //link.dataType = "json";
            link.href = data;
            link.download = filePath.substr(filePath.lastIndexOf('file_name=') + 10);
            link.dispatchEvent(new MouseEvent('click'));
            setTimeout(function () {
                // For Firefox it is necessary to delay revoking the ObjectURL
                window.URL.revokeObjectURL(data)
            }, 60);
        });
    }

    onClickDownload() {
        let { filePath, params } = this.state
        //params += '&download=true'
        //var url = window.location.origin + '/view?' + params
        //window.open(filePath)
        this.downloadFile(filePath)
    }

    viewScale = () => {
        var scale = this.state.scaleList[this.state.scaleIndex] * 100;

        return scale.toFixed(0)
    }

    onClickSignedBadge() {
        this.setState({
            showSigned: !this.state.showSigned
        })
    }

    private rotateNativePreview = async (rotation: number) => {
        if (this.nativeRotationInProgress || this.viewerUnmounted) return;
        this.nativeRotationInProgress = true;
        this.setState({ nativeRotating: true });
        let previewUrl: string | null = null;
        try {
            if (rotation !== 0) {
                const original = this.state.base64PDF;
                if (!(original instanceof ArrayBuffer)) throw new Error('Original PDF bytes unavailable');
                const { PDFDocument, degrees } = await import('pdf-lib');
                if (this.viewerUnmounted) return;
                // Always derive from the original, preserving each page's initial orientation.
                const pdf = await PDFDocument.load(original.slice(0), { updateMetadata: false });
                pdf.getPages().forEach(page => {
                    page.setRotation(degrees((page.getRotation().angle + rotation) % 360));
                });
                const bytes = await pdf.save({ updateFieldAppearances: false });
                if (this.viewerUnmounted) return;
                previewUrl = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
                this.nativePreviewUrls.add(previewUrl);
            }
            if (this.viewerUnmounted) return;
            const previousUrl = this.state.nativePreviewUrl;
            this.setState({ nativePreviewUrl: previewUrl, rotation }, () => {
                // The previous iframe is now detached. Original Blob URL stays available.
                if (previousUrl) {
                    URL.revokeObjectURL(previousUrl);
                    this.nativePreviewUrls.delete(previousUrl);
                }
            });
        } catch (error) {
            console.warn('[PDFView] native rotation failed:', error);
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl);
                this.nativePreviewUrls.delete(previewUrl);
            }
            if (!this.viewerUnmounted) {
                Swal.fire({ icon: 'error', title: 'หมุน PDF ไม่สำเร็จ', text: 'ไม่สามารถสร้างภาพตัวอย่างที่หมุนได้ กรุณาลองใหม่หรือดาวน์โหลดไฟล์ต้นฉบับ' });
            }
        } finally {
            this.nativeRotationInProgress = false;
            if (!this.viewerUnmounted) this.setState({ nativeRotating: false });
        }
    };

    onClickRotate = () => {
        if (this.state.useNativeViewer) {
            this.rotateNativePreview((this.state.rotation + 90) % 360);
        } else {
            this.setState(state => ({ rotation: (state.rotation + 90) % 360 }));
        }
    };
    static extractFileNameFromPath(filePath: string | null | undefined): string {
        if (!filePath) {
            return '';
        }
        try {
            const url = new URL(filePath, window.location.origin);
            const name = url.searchParams.get('file_name');
            if (name) {
                return name;
            }
        } catch {
            // filePath wasn't a parseable URL — fall back below
        }
        const idx = filePath.lastIndexOf('file_name=');
        return idx === -1 ? '' : filePath.substr(idx + 10);
    }

    getFileName = () => {
        return PDFView.extractFileNameFromPath(this.state.filePath);
    }

    // scrollToTop = () => window.scrollTo({ top: 0 });

    render() {
        const { filePath, readOnly, isSigned, signedBy, signedOn, showSigned, fetching, useNativeViewer, blobUrl, detecting, numPages, pageNumber, scaleIndex, scaleList } = this.state

        // Show loader when fetching
        if (!filePath && fetching) {
            return (
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'white',
                        position: 'fixed',
                        zIndex: 9_999,
                        left: 0,
                        top: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <Spinner color="primary" />
                </div>
            );
        }

        if (!filePath || !blobUrl) {
            return null;
        }

        // While detecting: show spinner + run hidden Document for onDocumentLoadSuccess to fire
        if (detecting) {
            return (
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'white',
                        position: 'fixed',
                        zIndex: 9_999,
                        left: 0,
                        top: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <div style={{ position: 'absolute', height: 0, overflow: 'hidden', pointerEvents: 'none' }}>
                        <Document
                            file={blobUrl}
                            onLoadSuccess={this.onDocumentLoadSuccess}
                            onLoadError={this.onDocumentLoadError}
                            options={options}
                        />
                    </div>
                    <Spinner color="primary" />
                </div>
            );
        }

        if (useNativeViewer && blobUrl) {
            const nativeUrl = this.state.nativePreviewUrl || blobUrl;
            return (
                <div
                    className="Showcase Showcase--react-pdf"
                    onContextMenu={(e) => e.preventDefault()}
                >
                    <div className="react-component" style={{ flex: 1, position: 'relative', display: 'flex', flexDirection: 'column', height: '100vh' }}>
                        <div
                            className="native-viewer-filename"
                            title={this.getFileName()}
                            style={{ padding: '6px 12px', background: '#f0f0f0', borderBottom: '1px solid #ddd', fontSize: '13px', fontWeight: 600, color: '#333', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                            {this.getFileName()}
                        </div>
                        <iframe
                            // WebView2 may ignore fragment-only changes after PDF load.
                            // Remount on page/zoom changes so open parameters are read on navigation.
                            // Reuse the fetched Blob: no additional file/decryption API request.
                            key={`${nativeUrl}:${pageNumber}:${scaleIndex}`}
                            src={`${nativeUrl}#toolbar=0&page=${pageNumber}&zoom=${Math.round(scaleList[scaleIndex] * 100)}`}
                            style={{ width: '100%', flex: 1, border: 'none', display: 'block' }}
                            title="PDF Viewer"
                        />
                        <div style={{ zIndex: 1_000 }} className="page-controls">
                            <button id="btnPreviousPage" type="button" onClick={this.onClickGoToPreviousPage}>‹</button>
                            <span>{pageNumber} of {numPages}</span>
                            <button id="btnNextPage" type="button" onClick={this.onClickGoToNextPage}>›</button>
                            <span>&nbsp;|&nbsp;</span>
                            <button id="btnScaleDown" type="button" onClick={this.onClickScaleDown}>-</button>
                            <span>{this.viewScale()}%</span>
                            <button id="btnScaleUp" type="button" onClick={this.onClickScaleUp}>+</button>
                            {readOnly == false &&
                                <div style={{ display: "inline-block" }}>
                                    <span>&nbsp;|&nbsp;</span>
                                    <button id="btnDownload" type="button" onClick={this.onClickDownload}><FaDownload /></button>
                                </div>
                            }
                            <button id="btnRotate" type="button" onClick={this.onClickRotate}
                                disabled={this.state.nativeRotating}
                                title="หมุนทุกหน้า 90°" aria-label="หมุนทุกหน้า 90 องศา" aria-busy={this.state.nativeRotating}>
                                {this.state.nativeRotating ? <Spinner size="sm" /> : <FiRotateCw />}
                            </button>
                        </div>
                        {isSigned &&
                            <div className="show-signed">
                                <button id="btnSigned" type="button" style={{ position: 'relative', opacity: 1, background: 'none', border: 'none', height: '60px', width: '30px' }} onClick={this.onClickSignedBadge}>
                                    <span style={{ position: 'absolute', top: '5px', left: '3px' }}>
                                        <FaCertificate style={{ fontSize: '24px', color: 'white', margin: 0 }} />
                                    </span>
                                    <span style={{ position: 'relative', top: '-10px', left: '0' }}>
                                        <FaCheck style={{ fontSize: '14px', color: 'rgb(80, 200, 120)', margin: 0 }} />
                                    </span>
                                </button>
                                {showSigned &&
                                    <div className="signed-data">
                                        <span className="truncate_text" data-id="name">
                                            <p style={{ fontSize: '14px', color: 'white', margin: 0 }}>
                                                Original PDF — Signed By: {signedBy}
                                            </p>
                                        </span>
                                        <span className="truncate_text" data-id="date">
                                            <p style={{ fontSize: '11px', color: 'white', margin: 0 }}>
                                                Signed On: {signedOn}
                                            </p>
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            );
        }

        return (
            <div
                className="Showcase Showcase--react-pdf"
                onContextMenu={(e) => e.preventDefault()}
            >
                <div className="pdf-paging">
                    {/* {
                        Array
                            .from({ length: this.state.numPages })
                            .map((_, index) => (
                                // Don't change it. It's a lazy loading.
                                <React.Suspense
                                    key={index}
                                    fallback={<p>Cannot load pdf</p>}
                                >
                                    <PDFThumnail
                                        file={blobUrl}
                                        onLoadError={this.onDocumentLoadError}
                                        onLoadSuccess={this.onDocumentLoadSuccess}
                                        options={options}
                                        pageNumber={(index + 1)}
                                        currentPageNumber={this.state.pageNumber}
                                        scale={this.state.scaleList[0]}
                                        onClick={(_) => this.onClickPageThumnail(index + 1)}
                                    />
                                </React.Suspense>
                            ))
                    } */}
                    {
                        this.state.pdfDocumentProxy
                        && Array
                            .from({ length: this.state.numPages })
                            .map((_, index) => (
                                <Thumbnail
                                    key={index}
                                    pdf={this.state.pdfDocumentProxy}
                                    pageNumber={index + 1}
                                    scale={0.25}
                                    // rotate={((this.state.defaultPageRotates[index] ?? 0) + this.state.rotation) % 360}
                                    onItemClick={({ pageNumber }) => this.onClickPageThumnail(pageNumber)}
                                    className={index + 1 === this.state.pageNumber ? "pdf-active" : ''}
                                />
                            ))

                    }
                </div>
                <div
                    className="react-component"
                    onContextMenu={(e) => e.preventDefault()}
                >
                    <Document
                        className="selected-document"
                        file={blobUrl}
                        onLoadError={this.onDocumentLoadError}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        // className="pdf-container"
                        options={options}
                    >
                        <Page
                            canvasRef={this.pageCanvas}
                            onRenderSuccess={this.onPageRenderSuccess}
                            pageNumber={this.state.pageNumber}
                            scale={this.state.scaleList[this.state.scaleIndex]}
                            rotate={((this.state.defaultPageRotates[this.state.pageNumber - 1] ?? 0) + this.state.rotation) % 360}
                            renderTextLayer={false}
                        />
                        <div style={{ zIndex: 1_000 }} className="page-controls">
                            <button id="btnPreviousPage" type="button" onClick={this.onClickGoToPreviousPage}>‹</button>
                            <span>{this.state.pageNumber} of {this.state.numPages}</span>
                            <button id="btnNextPage" type="button" onClick={this.onClickGoToNextPage}>›</button>
                            <span>&nbsp;|&nbsp;</span>
                            <button id="btnScaleDown" type="button" onClick={this.onClickScaleDown}>-</button>
                            <span>{this.viewScale()}%</span>
                            <button id="btnScaleUp" type="button" onClick={this.onClickScaleUp}>+</button>
                            {readOnly == false &&
                                <div style={{ display: "inline-block" }}>
                                    <span>&nbsp;|&nbsp;</span>
                                    <button id="btnDownload" type="button" onClick={this.onClickDownload}><FaDownload /></button>
                                </div>
                            }
                            <button id="btnRotate" type="button" onClick={this.onClickRotate}><FiRotateCw /></button>
                        </div>
                        {isSigned &&
                            <div className="show-signed">
                                <button id="btnSigned" type="button" style={{ position: 'relative', opacity: 1, background: 'none', border: 'none', height: '60px', width: '30px' }} onClick={this.onClickSignedBadge}>
                                    <span style={{ position: 'absolute', top: '5px', left: '3px' }}>
                                        <FaCertificate style={{ fontSize: '24px', color: 'white', margin: 0 }} />
                                    </span>
                                    <span style={{ position: 'relative', top: '-10px', left: '0' }}>
                                        <FaCheck style={{ fontSize: '14px', color: 'rgb(80, 200, 120)', margin: 0 }} />
                                    </span>
                                </button>
                                {showSigned &&
                                    <div className="signed-data">
                                        <span className="truncate_text" data-id="name">
                                            <p style={{ fontSize: '14px', color: 'white', margin: 0 }}>
                                                Signed By: {signedBy}
                                            </p>
                                        </span>
                                        {/*<span className="truncate_text" data-id="email">*/}
                                        {/*    <p style={{ fontSize: '11px', color: 'rgb(var(--grey_5))', margin: 0 }}>*/}
                                        {/*        {signedEmail}*/}
                                        {/*    </p>*/}
                                        {/*</span>*/}
                                        <span className="truncate_text" data-id="date">
                                            <p style={{ fontSize: '11px', color: 'white', margin: 0 }}>
                                                Signed On: {signedOn}
                                            </p>
                                        </span>
                                    </div>
                                }
                            </div>
                        }
                    </Document>
                </div>
            </div>
        );
    }
}

export default PDFView;
